export interface RoadSignRenderConfig {
  readonly maximumCrossingToRoadDistanceM: number;
  readonly minimumAxisAgreement: number;
  readonly curbClearanceM: number;
  readonly crossingHalfLengthM: number;
  readonly crossingEdgeClearanceM: number;
  readonly fallbackAlongStepM: number;
  readonly fallbackAttemptCount: number;
  readonly fallbackRoadsideStepM: number;
  readonly fallbackRoadsideInwardAttemptCount: number;
  readonly fallbackRoadsideOutwardAttemptCount: number;
  readonly poleHeightM: number;
  readonly poleRadiusM: number;
  readonly plateWidthM: number;
  readonly plateHeightM: number;
  readonly plateDepthM: number;
  readonly plateCenterHeightM: number;
  readonly buildingClearanceM: number;
  readonly treeClearanceM: number;
  readonly regulatoryApproachOffsetM: number;
  readonly regulatoryRoadsideClearanceM: number;
  readonly regulatoryFallbackAlongStepM: number;
  readonly regulatoryFallbackAttemptCount: number;
  readonly regulatoryPlateCenterHeightM: number;
  readonly regulatoryPlateSizeM: number;
  readonly supplementaryPlateWidthM: number;
  readonly supplementaryPlateHeightM: number;
}

/**
 * Low-detail sign 533/534 proportions and conservative placement tolerances.
 * Crossings themselves come from the separable OSM snapshot and must already
 * have survived the offline GRPK road/axis match before a sign can render.
 */
export const ROAD_SIGN_RENDER_CONFIG:
  Readonly<RoadSignRenderConfig> = Object.freeze({
    maximumCrossingToRoadDistanceM: 6,
    minimumAxisAgreement: Math.cos(Math.PI * 30 / 180),
    curbClearanceM: 0.62,
    crossingHalfLengthM: 2.35,
    crossingEdgeClearanceM: 0.48,
    fallbackAlongStepM: 0.75,
    fallbackAttemptCount: 40,
    fallbackRoadsideStepM: 0.18,
    fallbackRoadsideInwardAttemptCount: 3,
    fallbackRoadsideOutwardAttemptCount: 32,
    poleHeightM: 2.72,
    poleRadiusM: 0.052,
    plateWidthM: 0.72,
    plateHeightM: 0.72,
    plateDepthM: 0.055,
    plateCenterHeightM: 2.31,
    buildingClearanceM: 0.18,
    treeClearanceM: 0.42,
    regulatoryApproachOffsetM: 1.8,
    regulatoryRoadsideClearanceM: 0.62,
    regulatoryFallbackAlongStepM: 0.7,
    regulatoryFallbackAttemptCount: 7,
    regulatoryPlateCenterHeightM: 2.28,
    regulatoryPlateSizeM: 0.72,
    supplementaryPlateWidthM: 0.58,
    supplementaryPlateHeightM: 0.24,
  });
